var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNewMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-new-media",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.611,
    height: 93.933,
    viewBox: "0 0 118.611 93.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 118.611,
    height: 93.932,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M95.939,0H22.672A22.7,22.7,0,0,0,0,22.672V71.26A22.7,22.7,0,0,0,22.672,93.932H95.939A22.7,22.7,0,0,0,118.611,71.26V22.672A22.7,22.7,0,0,0,95.939,0m15.281,71.26A15.3,15.3,0,0,1,95.939,86.542H22.672A15.3,15.3,0,0,1,7.391,71.26V22.672A15.3,15.3,0,0,1,22.672,7.391H95.939a15.3,15.3,0,0,1,15.281,15.281Z",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M94.854,45.031A24.779,24.779,0,1,0,119.634,69.81,24.807,24.807,0,0,0,94.854,45.031m0,42.168A17.389,17.389,0,1,1,112.243,69.81,17.408,17.408,0,0,1,94.854,87.2",
    transform: "translate(-35.548 -22.844)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M182.391,30.909a5.914,5.914,0,1,0,5.914,5.914,5.914,5.914,0,0,0-5.914-5.914",
    transform: "translate(-89.525 -15.68)",
    fill: "#1152e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewMedia);
export default __webpack_public_path__ + "static/media/icon-new-media.6dc3cb830142b72f06c52696b57d1165.svg";
export { ForwardRef as ReactComponent };